import React from "react";
import { HOMESTAY } from "@/lib/data";

const seoLinks = [
  "Homestay near Nandi Hills",
  "Skandagiri Homestay",
  "Isha Foundation stay Bangalore",
  "Weekend getaway near Bangalore",
  "IPL screening homestay Nandi Hills",
  "Sunset view villa Nandi Hills",
  "Sunrise stay Chikkaballapura",
  "3BR villa near Bangalore",
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-mrn-wood text-mrn-cream pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-baseline gap-2">
              <span className="font-display text-5xl tracking-tight">Mrinmaya</span>
              <span className="font-accent text-mrn-amber text-lg">vacation home</span>
            </div>
            <p className="mt-5 text-mrn-sand/90 max-w-md">
              A 3-bedroom open-brick villa at the foothills of Nandi Hills. Built
              for slow weekends, movie nights and memorable mornings.
            </p>
            <div className="mt-6 space-y-2 text-sm">
              <a
                data-testid="footer-phone"
                href={`tel:${HOMESTAY.contact.phone}`}
                className="block link-underline w-fit text-mrn-sand"
              >
                {HOMESTAY.contact.phoneDisplay}
              </a>
              <a
                data-testid="footer-email"
                href={`mailto:${HOMESTAY.contact.email}`}
                className="block link-underline w-fit text-mrn-sand break-all"
              >
                {HOMESTAY.contact.email}
              </a>
              <div className="text-mrn-sand/70">
                {HOMESTAY.location}
              </div>
            </div>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.3em] text-mrn-amber font-medium">
              Explore
            </p>
            <ul className="mt-5 space-y-3 text-sm text-mrn-sand">
              <li><a href="/#stay" className="link-underline">The Stay</a></li>
              <li><a href="/#amenities" className="link-underline">Amenities</a></li>
              <li><a href="/#experiences" className="link-underline">Experiences</a></li>
              <li><a href="/#pricing" className="link-underline">Pricing</a></li>
              <li><a href="/blog" className="link-underline">Travel Guides</a></li>
              <li>
                <a
                  href={HOMESTAY.contact.airbnb_url}
                  target="_blank"
                  rel="noreferrer"
                  className="link-underline"
                >
                  View listing on Airbnb
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-mrn-amber font-medium">
              Popular searches
            </p>
            <ul className="mt-5 space-y-2.5 text-xs text-mrn-sand/80">
              {seoLinks.map((s) => (
                <li key={s}>
                  <a
                    href="/#inquiry"
                    className="link-underline"
                    data-testid={`seo-link-${s.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-mrn-sand/20 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-mrn-sand/60">
          <span>© {new Date().getFullYear()} Mrinmaya Vacation Home. All rights reserved.</span>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <a
              href="/terms"
              data-testid="footer-terms"
              className="link-underline hover:text-mrn-sand"
            >
              Terms & Conditions
            </a>
            <a
              href="/privacy"
              data-testid="footer-privacy"
              className="link-underline hover:text-mrn-sand"
            >
              Privacy Policy
            </a>
            <a
              href="/refund-policy"
              data-testid="footer-refund"
              className="link-underline hover:text-mrn-sand"
            >
              Refund Policy
            </a>
            <a
              href="/host-info"
              data-testid="footer-host-info"
              className="link-underline hover:text-mrn-sand"
            >
              Host Info
            </a>
          </div>
          <span>Chikkaballapura, Karnataka · India</span>
        </div>
      </div>
    </footer>
  );
}
